import './ChangeCount.scss';
import classNames from 'classnames';
import { getChangeRecordClassName } from '@timeline/@arch/lib';
import { Statistic } from 'antd';
import { TimelineChangeType } from '@sonar-software/sonar-core';
import { ArrowDownOutlined, ArrowUpOutlined, SwapOutlined } from '@ant-design/icons';
import React, { useCallback } from 'react';
const getChangeRecordIndicator = (changeType) => {
    switch (changeType) {
        case TimelineChangeType.Discovered:
            return React.createElement(ArrowUpOutlined, null);
        case TimelineChangeType.Modified:
            return React.createElement(SwapOutlined, null);
        case TimelineChangeType.Vanished:
            return React.createElement(ArrowDownOutlined, null);
        default:
            return null;
    }
};
export const ChangeCount = ({ changeType, count, highlighted, filtered, loading, objectType, onClick, selected }) => {
    const changeClassName = getChangeRecordClassName(changeType, count);
    const indicator = getChangeRecordIndicator(changeType);
    const className = classNames('timeline-change-count clickable', {
        faded: filtered && !selected,
        highlighted,
        selected
    });
    const handleOnClick = useCallback(() => {
        onClick(changeType, objectType);
    }, [changeType, objectType, onClick]);
    return (React.createElement("div", { className: className, key: changeType, onClick: handleOnClick },
        React.createElement(Statistic, { className: changeClassName, loading: Boolean(loading), prefix: indicator, value: count })));
};
